import { render, staticRenderFns } from "./getInsView.vue?vue&type=template&id=35e7209a&scoped=true&"
import script from "./getInsView.vue?vue&type=script&lang=js&"
export * from "./getInsView.vue?vue&type=script&lang=js&"
import style0 from "./getInsView.vue?vue&type=style&index=0&id=35e7209a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e7209a",
  null
  
)

export default component.exports